interface CustomButtonProps {
    title: string;
    color?: string | null;
    textColor?: string;
    handleClick?: () => void;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
    isSmall?: boolean;
    isLarge?: boolean;
    isMedium?: boolean;
    className?: string;
    icon?: any
}

const CustomButton: React.FC<CustomButtonProps> = ({
    title,
    color,
    textColor,
    handleClick,
    disabled,
    type = 'button',
    isLarge,
    isMedium,
    isSmall,
    className = '',
    icon
}) => {
    const padding = isLarge
        ? 'px-8 py-3'
        : isMedium
        ? 'px-6 py-2.5'
        : isSmall
        ? 'px-3 py-1.5'
        : 'py-2 px-4';

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={type === 'submit' ? undefined : handleClick}
            className={`flex items-center gap-2 ${color ?? ''} ${textColor ?? 'text-white'} ${padding} rounded-lg text-sm outline outline-[0.5px] outline-gray-300 ${className} ${
                disabled ? 'opacity-50 cursor-not-allowed' : ''
            }`}
        >
            {icon} {title}
        </button>
    );
};

export default CustomButton;
